import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { getDate } from '@/finsight/ui/components/deals/DealListTable/helpers';
import type IDealCellData from '@/finsight/ui/components/deals/DealListTable/cells/types';

const DealDateCell = ({ row: deal }: { row: IDealCellData }) => {
  const { pricingDate, announcedDate } = deal;
  if (!pricingDate && !announcedDate) {
    return '-';
  }

  return (
    <div data-test="dealRowDates">
      { !!pricingDate && (
      <Tooltip content="Issue Date">
          { getDate(pricingDate) }
      </Tooltip>
      ) }

      { !pricingDate && announcedDate && (
        <Tooltip content="Announced Date">
            { getDate(announcedDate) }
        </Tooltip>
      ) }
    </div>
  );
};

export default DealDateCell;
